import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function CasinoSuperskokResults(props) {
    const [state, setState] = useState({
        resultsNumber: 25,
        playerNickname: null,
        playerName: null,
        showPlayerDetails: false,
        playerDetails: [],
        finalResultsNumber: 100
    });

    useEffect(() => {
        if (props.player) setState({ ...state, playerNickname: props.player.nickname });
    }, [props.player]);

    function isStarted() {
        return new Date().getTime() > new Date(props.info.aktivnoOd).getTime();
    }

    function showPlayerDetails(playerId) {
        casino.repos.casinoSuperskokRepo.rezultatiIgrac(playerId, props.kampanja).then((res) => {
            setState(
                {
                    ...state,
                    playerDetails: res,
                    showPlayerDetails: true,
                    playerName: props.results.find(it => it.igracID == playerId).igracIme
                })
        });
    }

    function renderResults() {
        return (
            <span>
                <table className="order-table">
                    <thead>
                        <tr>
                            <th>Plasman</th>
                            <th>Natjecatelj</th>
                            <th>Bodovi ukupno</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.results.slice(0, state.resultsNumber).map((player, index) => renderPlayerRow(player, index))}
                    </tbody>
                </table>
                {state.resultsNumber < 100 && props.results.length > 25 && <div className="text-center">
                    <button className="btn medium fill gray blue margin-top-small no-text-transform" onClick={() => setState({ ...state, resultsNumber: state.resultsNumber + 25 })}>
                        <span className="icon ico-chevron-down"></span>
                        &nbsp; <span>Prikaži više</span>
                    </button>
                </div>}
            </span>
        )
    }

    function renderPlayerRow(player, index) {
        return (
            <tr key={index} className={state.playerNickname == player.nickname ? 'selected' : ''} onClick={() => showPlayerDetails(player.igracID)}>
                <td>{player.ordinalNumber}.
                    {state.playerNickname == player.nickname && <span className="mark"></span>}
                    <span className={player.ordinalNumber > 9 ? 'img-list double' : 'img-list'}></span></td>
                <td>{player.igracIme}</td>
                <td>{player.points}</td>
            </tr>
        )
    }

    function renderPlayerDetails() {
        return (
            <div className={"modal-dialog-overlay" + (state.showPlayerDetails ? ' active' : '')}>
                <div className="modal-dialog--inner flex-column">

                    <div className="modal-dialog-header clearfix">
                        <div className="modal-dialog--name">
                            <span className="naziv">Rezultati - {state.playerName}</span>
                        </div>
                        <a className="active pull-right as-link link link-1" onClick={(e) => { e.preventDefault(); setState({ ...state, showPlayerDetails: false }) }}>
                            <span className="close-icon icon ico-close-thin"></span>
                        </a>
                    </div>

                    <div className="modal-dialog-container flex-1">
                        <div className="modal-dialog-container--inner flex-equal-size">
                            <div>
                                <div className="relative">
                                    <div>
                                        <table className="table-1 v2">
                                            <thead>
                                                <tr>
                                                    <th className="text-left text text-6">Naziv Igre</th>
                                                    <th className="text-center text text-6">Datum i vrijeme</th>
                                                    <th className="text-right text text-6">Max bodovi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.playerDetails.map((info, index) => renderPlayerDetailsRow(info, index))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function renderPlayerDetailsRow(info, index) {
        let playIconCss = null;
        let game = info.igraSifra != null ? props.games.find(it => it.s == info.sifraMobile) : null;
        if (game) {
            playIconCss = game.p && (game.p.indexOf("o") != -1) ? 'icon-play-disabled' : 'icon-play';
        }

        let kampanja = props.kampanja || 'fazi';
        return (
            <tr className="horizontal-lines" key={index}>
                <td className="game-name">
                    {game && game.s && <NavLink to={{ pathname: '/promotions/casino-superskok/' + kampanja + '/game/' + props.brands[game.bID].nameNormalizirano + '/' + casino.utils.normalizeString(game.n) }}><span className={playIconCss}></span></NavLink>}
                    {game && <span className="game-title">{game.n}</span>}
                    {!game && !info.naziv && <span className="not-played">
                        <img src="content/images/bonusi/casinosuperskok/sad.png" />
                        <span>Nije odigrano</span>
                    </span>}
                    {!game && info.naziv && <><span className='icon-play-disabled'></span><span>{info.naziv}</span></>
                    }
                </td>
                <td className="game-date text-center text text-6">{casino.utils.dateToShortDateString(new Date(info.datumDan))}. {info.igraSifra != null && casino.utils.dateToTimeString(new Date(info.datum))}</td>
                <td className="text-right">{info.points}</td>
            </tr>
        )
    }

    function renderFinalResults() {
        return (
            <span>
                <table className="order-table">
                    <thead>
                        <tr>
                            <th>Plasman</th>
                            <th>Natjecatelj</th>
                            <th className="award">Nagrada</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.finalResults.slice(0, state.finalResultsNumber).map((player, index) => renderPlayerRowFinal(player, index))}
                    </tbody>
                </table>
                {state.finalResultsNumber < 500 && props.finalResults.length > 25 && <div className="text-center">
                    <button className="btn medium fill gray blue margin-top-small no-text-transform" onClick={() => setState({ ...state, finalResultsNumber: state.finalResultsNumber + 25 })}>
                        <span className="icon ico-chevron-down"></span>
                        &nbsp; <span>Prikaži više</span>
                    </button>
                </div>}
            </span>
        )
    }

    function renderPlayerRowFinal(player, index) {
        return (
            <tr key={index}>
                <td>{(index + 1)}.
                    <span className={player.ordinalNumber > 9 ? 'img-list double' : 'img-list'}></span></td>
                <td>{player.igracIme}</td>
                <td className="award">
                    {player.vrstaNagrade == 1 && player.nagradaNaziv && player.nagradaNaziv + ' ' +casino.utils.numberWithCurrencyFromated(player.nagrada, props.info.valuta)}
                    {player.vrstaNagrade == 1 && !player.nagradaNaziv && casino.utils.numberWithCurrencyFromated(player.nagrada, props.info.valuta)}
                    {player.vrstaNagrade == 2 && <b>{player.nagradaNaziv}</b>}
                    {player.vrstaNagrade == 3 && <b>{player.nagrada + ' Supera'}</b>}
                </td>
            </tr>
        )
    }

    return (
        <div className="casino-superskok-section">
            <h2 className="order">
                {!props.info.uplaceno && isStarted() && 'Trenutni poredak'}
                {props.info.uplaceno && 'Pobjednici SuperSkok utrke'}
            </h2>
            {!props.info.uplaceno && isStarted() && <p className="total-players"><span className="red">{props.activePlayers} igrača</span> trenutno sudjeluje u SuperSkok utrci.</p>}
            {props.info.uplaceno && <p className="total-players"><span className="red">{props.activePlayers} igrača</span> je završilo SuperSkok utrku.</p>}
            <div className="divider order"></div>
            {!props.info.uplaceno && isStarted() && renderResults()}
            {props.info.uplaceno && renderFinalResults()}
            {!props.info.uplaceno && renderPlayerDetails()}
        </div>
    )
}